import { fabric } from "fabric";
import { v4 } from "uuid";
import { CanvasHandler } from "../../handlers";
import { FabricEvent, FabricObject } from "../../types/FabricCustomType";
import { IObjectDesingner } from "../../types/HandlerObjectType";
import { ZoneProperties } from "./properties";

class RectangleZone extends ZoneProperties implements IObjectDesingner {
  constructor(canvasHandler: CanvasHandler) {
    super(canvasHandler);
  }
  onRotated(event: FabricEvent) {
    throw new Error("Method not implemented.");
  }

  public onInit() {
    this.canvasHandler.interactionHandler.drawing("rectangleZone", "crosshair");
    this.canvasHandler.activeShape = null;
  }

  public onMouseDblClick(event: FabricEvent<Event>) {
    throw new Error("Method not implemented.");
  }

  public onMousedown(event: FabricEvent<MouseEvent>) {
    const { x, y } = this.canvasHandler.canvas.getPointer(event.e);
    this.addPoint(x, y);
  }

  public onMousemove(event: FabricEvent<MouseEvent>) {
    const { x, y } = this.canvasHandler.canvas.getPointer(event.e);
    if (!this.canvasHandler.isDown) return;
    this.updating(x, y);
    this.canvasHandler.canvas.renderAll();
  }

  public onMouseup(event: FabricEvent<MouseEvent>) {
    const { x, y } = this.canvasHandler.canvas.getPointer(event.e);
    this.generate(false, false);
    this.finish();
  }

  private addPoint(x: number, y: number) {
    this.canvasHandler.isDown = true;
    const editable = this.canvasHandler.editable;
    const id = v4();
    this.canvasHandler.activeShape = new fabric.Rect({
      name: "New rectangle",
      left: x,
      top: y,
      visible: true,
      originX: "left",
      originY: "top",
      width: 0,
      height: 0,
      angle: 0,
      fill: "#cccccc",
      stroke: "#727272",
      strokeWidth: 4,
      strokeUniform: true,
      transparentCorners: false,
      rx: 4,
      ry: 4,
      opacity: 1,
      objectCaching: !this.canvasHandler.editable,
      type: "rect",
      hasControls: editable,
      hasBorders: editable,
      selectable: editable,
      lockMovementX: !editable,
      lockMovementY: !editable,
      hoverCursor: !editable ? "pointer" : "move",
    }) as FabricObject<fabric.Rect>;

    this.canvasHandler.activeShape.set({
      id: id,
      superType: "rectangleZone",
      container: this.canvasHandler.container.id,
      editable: editable,
      category: "",
      capacity: 100,
      typeCapacity: "generalAdmission",
      text: "Label",
      displayedLabel: false,
    });

    this.canvasHandler.objText = new fabric.Text("Label", {
      fontSize: 16,
      left: x,
      top: y,
      angle: 0,
      fill: "#727272",
      stroke: "#727272",
      strokeWidth: 0,
      strokeUniform: true,
      fontFamily: "Roboto",
      opacity: 1,
      type: "textbox",
      hasControls: editable,
      hasBorders: editable,
      selectable: editable,
      lockMovementX: !editable,
      lockMovementY: !editable,
      hoverCursor: !editable ? "pointer" : "move",
      text: "Label",
    }) as FabricObject<fabric.Text>;

    this.canvasHandler.objText.set({
      id: id,
      superType: "textbox",
      container: this.canvasHandler.container.id,
      editable,
      displayedLabel: false,
    });

    this.canvasHandler.activeShape.guides = {};
    this.canvasHandler.canvas.add(this.canvasHandler.activeShape);
  }

  private updating(x: number, y: number) {
    if (this.canvasHandler.originPointer.x > x)
      this.canvasHandler.activeShape.set({ left: Math.abs(x) });
    if (this.canvasHandler.originPointer.y > y)
      this.canvasHandler.activeShape.set({ top: Math.abs(y) });
    this.canvasHandler.activeShape.set({
      width: Math.abs(this.canvasHandler.originPointer.x - x),
    });
    this.canvasHandler.activeShape.set({
      height: Math.abs(this.canvasHandler.originPointer.y - y),
    });
  }

  private generate(isDown: any, loaded: any) {
    const { editable, gridOption, onAdd } = this.canvasHandler;
    const id = v4();

    let group = new fabric.Group(
      [this.canvasHandler.activeShape, this.canvasHandler.objText],
      {
        left: this.canvasHandler.originPointer.x,
        top: this.canvasHandler.originPointer.y,
        hasControls: editable,
        hasBorders: editable,
        selectable: editable,
        type: "group",
        subTargetCheck: true,
        centeredRotation: true,
        centeredScaling: true,
      }
    ) as FabricObject<fabric.Group>;

    group.set({
      id: id,
      superType: "rectangleZone",
      tooltip: {
        enabled: true,
      },
    });

    // eliminamos el objeto creado incialmente del canvas
    this.canvasHandler.canvas.remove(this.canvasHandler.activeShape);
    //añadimos al canvas el nuevo objeto agrupado
    this.canvasHandler.canvas.add(group);

    //se establecen en 0 la posicion del label en X y Y
    group.item(1).left = 0;
    group.item(1).top = 0;

    // se le resta la mitad de la anchura y altura del texto por defecto para centrar el texto con el objeto
    const widthText = group.item(1).width ?? 0;
    const heightText = group.item(1).height ?? 0;
    group.item(1).set({
      left: -(widthText / 2),
      top: -(heightText / 2),
    });

    this.canvasHandler.objects = this.canvasHandler.getObjects();

    if (group.dblclick)
      group.on("mousedblclick", this.canvasHandler.eventHandler.object.mousedblclick);
    if (group.superType === "node") this.canvasHandler.portHandler.create(group);
    if (group.superType === "node") group.setShadow(group.stroke);
    if (gridOption?.enabled ?? false) this.canvasHandler.gridHandler.setCoords(group);
    if (!this.canvasHandler.transactionHandler.active && !loaded)
      this.canvasHandler.transactionHandler.save("add");
    if (onAdd && editable && !loaded) onAdd(group);

    this.canvasHandler.isDown = isDown;
    this.canvasHandler.activeShape = null;
  }

  private finish() {
    //this.canvasHandler.canvas.remove(this.canvasHandler.activeShape);
    this.canvasHandler.activeShape = null;
    this.canvasHandler.canvas.renderAll();
    //this.canvasHandler.interactionHandler.selection();
  }
}
export default RectangleZone;
